import classNames from 'classnames'
import { confirmBase } from 'utils/ui'
import type { SendStatusResponse } from 'services/read-receipt'
import ReadReceiptDetailContent from './Content'

import styles from './style.module.scss'

import closeIcon24 from 'assets/images/icon-close-24.svg'

/**
 * 수신확인 메일 상세 팝업. (host 컨텍스트 — 5차 보완으로 viewer 에서 이동)
 *
 * - confirmBase 기반, footer = null (요구사항 §6-4)
 * - viewer iframe 안에서 직접 호출하면 마스크 영역이 iframe 으로 클립되므로
 *   `viewerWindow.NineNative.openReadReceiptDetailPopup(emailId)` 핸들러를 통해
 *   host 컨텍스트에서 호출되도록 한다 (viewerExt.tsx 참조).
 * - emailId 를 함께 받아 Content 가 readReceiptListenerStore 를 구독해 refresh
 *   결과를 자동 반영하도록 한다.
 */
export function openReadReceiptDetailPopup(opts: {
  emailId: string
  initialStatus: SendStatusResponse
}) {
  return confirmBase({
    wrapClassName: classNames(styles.readReceiptDetailPopup),
    width: 400,
    centered: true,
    title: null,
    content: <ReadReceiptDetailContent emailId={opts.emailId} initialStatus={opts.initialStatus} />,
    closable: true,
    closeIcon: <img src={closeIcon24} alt="close" />,
    footer: null,
    maskClosable: true,
  })
}
